export default __webpack_public_path__ + "media/devOpsCategory.155d59ab1e5207af31a27e9da3e0b8cc.svg";